export const BIGGEST_WINDOW_WIDTH = 1920;
export const LARGE_WINDOW_WIDTH = 1440;
export const SMALL_DESKTOP_WIDTH = 1366;
export const MEDIUM_WINDOW_WIDTH = 1024;
export const TABLET_WINDOW_WIDTH = 768;
export const MOBILE_WINDOW_WIDTH = 375;
